module.exports = __webpack_public_path__ + "img/dumpling_fars.fedcaf8a.jpg";